/**
 * @GENERATED from Figma node 3608:51048
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const BenchmarkDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#FFE178"
      fillRule="evenodd"
      d="M.48 0a.48.48 0 0 1 .48.48v19.495a3.065 3.065 0 0 0 3.065 3.065H23.52a.48.48 0 1 1 0 .96H4.025A4.024 4.024 0 0 1 0 19.975V.48A.48.48 0 0 1 .48 0"
      clipRule="evenodd"
    />
    <path
      fill="#FFE178"
      d="m22.631 18.176.147.442 1.222.42-.327.775-.28-.318-3.934.403L18.124 21H3l.447-.411.448-.42.253-.263 8.207-1.497-1.482-.318-.955-3.173 4.433 2.087-3.886-3.158-.788-5.864 5.342 7.214-3.893-8.37L11.794 0l5.636 13.343.393 3.654z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(BenchmarkDark);
export { ForwardRef as BenchmarkDark };
